<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useFVStore } from "@/stores/formvibes";
import { storeToRefs } from "pinia";
import { CircleCloseFilled, InfoFilled } from "@element-plus/icons-vue";

const props = defineProps([ 'isVisible','close', 'store', 'params' ]);
const store = useFVStore();

const {generalStates, isPro, dates} = storeToRefs(store);

const { settings_saved: settingsSaved } = window.fvGlobalVar;
const isExportReason = settingsSaved?.csv_export_reason;
const i18n = window.fvGlobalVar?.i18n;
const nonce = window?.fvGlobalVar.ajax_nonce;
const exportParams = ref([]);
const quickExportLimit = window.fvGlobalVar.quick_export_limit || 1000;
const exportReason = ref('');

watch([() => generalStates.value.selectedRowsId, () => generalStates.value.queryParams],( ) => {
    prepareParams();
});

const showDialog = ref(props.isVisible);

watch([() => props.isVisible],() => {
    if(props.isVisible){
        showDialog.value = true;
    }
})

onMounted(() => {
    prepareParams();
});

const prepareParams = () => {
    const queryParams = generalStates.value.queryParams;
    const params = {
        form_id: queryParams.formid,
        plugin: queryParams.plugin,
        from_date: dates.value[0] || "",
        to_date: dates.value[1] || "",
        description: exportReason.value,
        limit: parseInt(quickExportLimit),
        ajaxNonce: nonce,
        entry_column_exclude: isPro.value ? [] : ["fv_status"],
        is_pro: isPro.value,
        // download_type: downloadFileTypes.find((d) => d.active).key,
        download_type: "csv",
        fv_export_selected_rows: generalStates.value.selectedRowsId,
    };
    exportParams.value = JSON.stringify(params);
}

const downloadFileTypes = ref([
    {
        key: 'csv',
        value: 'CSV',
        icon: null,
        active: true,
    },
    {
        key: 'pdf',
        value: 'PDF',
        icon: null,
        active: false,
    },
]);
const closeDialog = () => {
    showDialog.value = false;
    props.close();
}


</script>

<template>
    
    <div>
        <el-dialog 
        v-model="showDialog" 
        :with-header="true"
        :show-close="true"
        @closed="closeDialog"
        width="500px"
        class="fv-quick-export-dialog"
        align-center="true"
        >
        <template #header="{ close, titleId, titleClass }">
            <div class="fv-header-title">
                <el-icon size="20">
                    <InfoFilled />
                </el-icon>
                <strong>Quick Export Data</strong>
            </div>
        </template>
        <form method="POST" className="fv-space-y-2" >
        <el-input
            v-model="exportReason"
            v-if="isExportReason"
            :rows="4"
            type="textarea"
            placeholder="Export Reason"
            @input="prepareParams"
        />
        <input
        type="hidden"
        name="fv_nonce"
        v-model="nonce"
        />
        <input
        name="fv_export_data"
        type="hidden"
        v-model="exportParams"
        />
        <div class="fv-export-btn">
            <el-button type="primary" name="btnExport" native-type="submit" @click="closeDialog">
                Export to 
						{{downloadFileTypes.find((d) => d.active).key === "csv"
							? "CSV"
							: "PDF"}}
            </el-button>    
        </div>
        
        <div>
            Export upto 1000 recent submissions.
            <a
                href="edit.php?post_type=fv_export_profile"
                rel="noreferrer"
                v-if="isPro"
            >
                Explore Export Profiles
            </a>
            <a
                href="https://formvibes.com/"
                target="_blank"
                rel="noreferrer"
                v-else
            >
                Need More? Upgrade to Pro
            </a>     
        </div>
        </form>
    </el-dialog>
        
    </div>
</template>